import { MessageCircle } from "lucide-react";
import { WA_CONFORT } from "../constants/site";

export const Confort = () => (
    <section
        id="confort"
        data-testid="confort-section"
        className="py-24 bg-[#181a1b] text-white border-b border-neutral-800"
    >
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
            <div className="max-w-3xl space-y-6">
                <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#ff6200]/20 text-[#ff6200] border border-[#ff6200]/40 text-xs font-bold uppercase tracking-wider">
                    Exclusividade TMZ Guincho
                </span>
                <h2 className="display-type text-3xl sm:text-5xl leading-tight">
                    PLANO CONFORT: TRANSPORTE DE PASSAGEIROS
                </h2>
                <p className="text-neutral-300 text-sm leading-relaxed">
                    Seu veículo precisa de guincho e você está acompanhado? Oferecemos a opção de
                    disponibilizar um veículo para transportar os passageiros e familiares até o
                    destino, com mais conforto e segurança, mediante um pequeno acréscimo no valor
                    do serviço.
                </p>
                <div className="pt-2">
                    <a
                        href={WA_CONFORT}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="confort-whatsapp-btn"
                        className="bg-[#ff6200] hover:bg-[#e05600] text-white px-6 py-3.5 rounded font-bold text-xs uppercase tracking-wider inline-flex items-center gap-2 transition-colors"
                    >
                        <MessageCircle className="w-4 h-4" />
                        Solicitar Orçamento Plano Confort no WhatsApp
                    </a>
                </div>
            </div>
        </div>
    </section>
);
